#!/usr/bin/env node
// palbe-gen — SDK-owned typed-client codegen for @palbase/web.
// Reads app-bound artifacts written by `palbase link`, or fetches the spec
// from an origin passed with --url, and writes the typed palbe.gen.ts module.
import process from 'node:process';
import { main } from './generate.js';

main(process.argv.slice(2)).then(
  (code) => process.exit(code),
  (err) => {
    process.stderr.write(`error: ${err instanceof Error ? err.message : String(err)}\n`);
    process.exit(1);
  },
);
